// postMessage handshake between ZoomMeetingEmbed (parent page) and ZoomClientFrame (the
// /zoomMeetingAdmin.html iframe). Meeting secrets travel here instead of the iframe URL, which
// would leak them into server logs and Referer headers.
export const FRAME_SOURCE = 'cme-zoom-frame';
export const EMBED_SOURCE = 'cme-zoom-embed';
export const CREDENTIALS_REQUEST = 'zoom-credentials-request';
export const CREDENTIALS = 'zoom-credentials';
// The frame tells the parent the browser's pop-up blocker stopped Zoom's broadcast page: { url }.
export const BROADCAST_BLOCKED = 'zoom-broadcast-blocked';

// Zoom's broadcast page (zoom.us/broadcast/<meeting>?c=...), which its web client opens in a
// new tab to start a custom live stream.
export function isZoomBroadcastUrl(url) {
  try {
    const { hostname, pathname } = new URL(String(url), window.location.href);
    return /(^|\.)zoom\.us$/i.test(hostname) && pathname.startsWith('/broadcast/');
  } catch {
    return false;
  }
}

// Only same-origin messages from the expected window, with the expected tag, are trusted.
export function isMessageFrom(e, win, source, kind) {
  return e.origin === window.location.origin
    && e.source === win
    && e.data?.source === source
    && e.data?.kind === kind;
}
